/**
 * Material layer thickness is stored in METRES (the pipeline scales all IFC
 * lengths to SI at extraction), but construction layers are conventionally
 * specified in millimetres. Shared by the property panel and the diff detail so
 * both surfaces always agree on the unit (a previous version rendered the raw
 * metre value with an "mm" suffix — a 100 mm layer displayed as "0 mm").
 */
export function formatThicknessMm(thicknessMetres: number): string {
  // ×1000 then trim float noise (0.013 * 1000 === 13.000000000000002).
  const mm = Number((thicknessMetres * 1000).toFixed(2));
  return `${mm} mm`;
}
